 const achievementData= [
    {title: "Best CFD Broker", text:'TradeON submit 2020'},
    {title: "Best Trading Experience", text:'Jordan forex expo '},
    {title: "Best Execution Broker", text:' Forex expo  (Dubai)'}
 ]
 export default achievementData 